export enum Routes {
  home = '/',
  about = '/about',
  projects = '/projects',
  resume = '/resume',
  hobby = '/hobby',
  contact = '/contact',
  galery = '/galery',
  cartproject = '/cartproject',
  conditions = '/conditions',
  certificates = '/certificates',
}
